<template>
  <v-dialog v-model="dialog" width="550" persistent>
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title>Xác nhận Phê duyệt Mượn Thiết bị</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-4">
        <div class="mb-3">
          Bạn có chắc chắn muốn phê duyệt yêu cầu mượn thiết bị có mã <strong>{{ item.code }}</strong>?
        </div>

        <v-card outlined class="pa-3 grey lighten-5">
          <div class="mb-1"><span class="grey--text">Người mượn:</span> <strong>{{ item.borrowerName }}</strong></div>
          <div class="mb-1"><span class="grey--text">Mục đích:</span> {{ item.purpose }}</div>
          <div class="mb-1"><span class="grey--text">Thời gian mượn:</span> {{ item | borrowTimeRange }}</div>
          <div v-if="item.items && item.items.length">
            <span class="grey--text">Thiết bị mượn:</span>
            <ul class="ml-4 mt-1">
              <li v-for="(it, idx) in item.items" :key="idx">
                {{ it.assetName || it.asset }}: <strong>{{ it.quantity }}</strong> {{ it.unit || 'Chiếc' }}
              </li>
            </ul>
          </div>
        </v-card>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="dialog = false">Hủy</v-btn>
        <v-spacer />
        <v-btn color="success" depressed :loading="loading" @click="onConfirm">
          <v-icon left small>mdi-check</v-icon> Xác nhận duyệt
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BorrowApproveDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityBorrows', ['approveBorrow']),
    async onConfirm() {
      if (!this.item || !this.item.id) return
      this.loading = true
      try {
        const res = await this.approveBorrow(this.item.id)
        if (res) {
          this.dialog = false
          this.$emit('updated')
        }
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
